import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import moment from 'moment';
// import storage from 'util/storage';
import { openGlobalModal } from 'actions/modal';
import { toggleLoading } from 'actions/global';

import { wrapFetch, wrapFetchAuth, wrapFetchFormData } from 'actions/endpoint';

export const getEventInfo = createAction('GET_EVENT_INFO', (id, giftId) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch(`api/web/replyGiftEvent/${giftId}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));
	const setting = [];
	if (status === 200) {
		data.reply_gift_event_settings.filter(i => i.id === id).map(i => setting.push(i));
		console.log(`SETTING:${data.reply_gift_event_settings.find(i => i.id === id)}`);
		return {
			gift: {
				title: setting[0].name,
				eventId: giftId,
				setId: id,
				threshold: setting[0].threshold,
			},
		};
	}
	return {};
});

export const checkQualification = createAction('CHECK_QUALIFICATION', (id, giftId, ref) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/replyGiftEvent/checkQualification?id=${id}&reply_gift_event_id=${giftId}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 401 || status === 400) {
		dispatch(openGlobalModal('eventNotMeetProduct'));
		console.log(data);
		return {
			notMeetProduct: data,
		};
	} else if (status === 200) {
		if (ref === 'check') {
			dispatch(getEventInfo(parseInt(id, 10), giftId));
			return {
				product: data,
			};
		} else if (ref === 'push') {
			dispatch(push(`/event/${giftId}/${id}`));
			dispatch(getEventInfo(id, giftId));
			return {
				product: data,
			};
		}
	}
	return {};
});

export const getProductGiftEventSetting = createAction('GET_PRODUCT_GIFT_EVENT_SETTING', (id, productId) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/user/product/${productId}/getAvailableReplyGiftEventSetting?reply_gift_event_id=${id}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			eventList: data,
		};
	}
	return {};
});

export const getGiftEvent = createAction('GET_GIFT_EVENT', (id, productId) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch(`api/web/replyGiftEvent/${id}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		if (productId === '') {
			return {
				giftInfo: data,
				eventList: data.reply_gift_event_settings,
			};
		} else if (productId !== '') {
			dispatch(getProductGiftEventSetting(id, productId));
			return {
				giftInfo: data,
			};
		}
	}
	return {};
});

export const getProductGiftEvent = createAction('GET_PRODUCT_GIFT_EVENT', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/user/product/${id}/getAvailableReplyGiftEvent`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			activityList: data,
			productId: id,
		};
	}
	return {};
});

export const getGiftEventList = createAction('GET_GIFT_EVENT_LIST', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch('api/web/replyGiftEvent', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		const event = data.sort((a, b) => moment(b.updated_at) - moment(a.updated_at));
		if (id !== '') {
			dispatch(getProductGiftEvent(id));
		} else if (id === '') {
			return {
				activityList: event,
			};
		}
	}
	return {};
});

export const signupEvent = createAction('SIGNUP_EVENT', (eventId, setId, productId, files, number, name, mobile, address) => async dispatch => {
	const data = new FormData();
	data.append('reply_gift_event_id', eventId);
	data.append('reply_gift_event_setting_id', setId);
	productId.map((id, index) =>
		data.append(`product[${index}][id]`, id));
	productId.map((id, index) =>
		data.append(`product[${index}][invoice_file]`, files));
	data.append('invoice_number', number);
	data.append('name', name);
	data.append('phone', mobile);
	data.append('address', address);

	dispatch(toggleLoading(true));
	const result = await wrapFetchFormData('api/web/userProductReplyGiftForm', {
		method: 'POST',
		body: data,
	});
	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(openGlobalModal('eventApplySuccess'));
	}
	return {};
});



// WEBPACK FOOTER //
// ./src/actions/event.js